<div class="d-flex align-items-center justify-content-center" style="height: 100px;">
    <a href="/">
        <img
          [src]="companyLogo"
          style="max-width: 120px; max-height: 80px; width: auto; height: auto; display: block; margin: 0 auto;"
          alt="company-logo"
        />
    </a>
    <a *ngIf="showToggle" href="javascript:void(0)" (click)="toggleMobileNav.emit()"
        class="d-flex justify-content-center ng-star-inserted icon-40 align-items-center mat-body-1"
        style="position: absolute; right: 10px;">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </a>
</div>
